module.exports = __webpack_public_path__ + "static/media/tel2.d3896826.png";